import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Post } from '../../../types'

@Component({
  selector: 'view-html-modal',
  styles: [`
    textarea {
      width: 100%;
      max-width: 100%;
      height: 400px;
    }
  `],
  template: `
    <modal (outsideClick)="closeModal()">
      <h4>View post HTML</h4>
      <hr class="brand-hr">
      <textarea id="postHtml{{post.id}}">
        {{post.content}}
      </textarea>
      <button (click)="closeModal()" class="top-buffer btn btn-default float-right">Cancel</button>
      <div style="clear: both;"></div>
    </modal>
  `
})
export class ViewHtmlModal {
  @Input() post:Post;
  @Output() onClose = new EventEmitter();

  closeModal() {
    this.onClose.emit('event')
  }

  ngAfterViewInit() {
    var textarea = document.getElementById('postHtml'+this.post.id);
    (<HTMLTextAreaElement> textarea).select()
  }
}
